interface SmallArrowRightIconProps {
  size?: number;
  className?: string;
}

const SmallArrowRightIcon: React.FC<SmallArrowRightIconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path d="M9.24742 5.92337C9.16902 6.00305 9.10679 6.09784 9.06433 6.20227C9.02186 6.30671 9 6.41873 9 6.53187C9 6.64501 9.02186 6.75704 9.06433 6.86147C9.10679 6.96591 9.16902 7.0607 9.24742 7.14038L13.0784 11.0656C13.1568 11.1453 13.219 11.2401 13.2615 11.3445C13.3039 11.449 13.3258 11.561 13.3258 11.6741C13.3258 11.7873 13.3039 11.8993 13.2615 12.0037C13.219 12.1082 13.1568 12.203 13.0784 12.2827L9.24742 16.2079C9.16902 16.2876 9.10679 16.3824 9.06433 16.4868C9.02186 16.5913 9 16.7033 9 16.8164C9 16.9296 9.02186 17.0416 9.06433 17.146C9.10679 17.2505 9.16902 17.3453 9.24742 17.4249C9.40414 17.5846 9.61614 17.6741 9.83712 17.6741C10.0581 17.6741 10.2701 17.5846 10.4268 17.4249L14.2661 13.4911C14.7361 13.009 15 12.3555 15 11.6741C15 10.9928 14.7361 10.3393 14.2661 9.85721L10.4268 5.92337C10.2701 5.76375 10.0581 5.67415 9.83712 5.67415C9.61614 5.67415 9.40414 5.76375 9.24742 5.92337Z" />
    </svg>
  );
};

export default SmallArrowRightIcon;
